import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import { Main } from './pages/Main';
import NotFound from './pages/NotFound';

function App() {
  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
